import { render, staticRenderFns } from "./enterprise.vue?vue&type=template&id=35bfdf25&scoped=true"
import script from "./enterprise.vue?vue&type=script&lang=js"
export * from "./enterprise.vue?vue&type=script&lang=js"
import style0 from "./enterprise.vue?vue&type=style&index=0&id=35bfdf25&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bfdf25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bfdf25')) {
      api.createRecord('35bfdf25', component.options)
    } else {
      api.reload('35bfdf25', component.options)
    }
    module.hot.accept("./enterprise.vue?vue&type=template&id=35bfdf25&scoped=true", function () {
      api.rerender('35bfdf25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/enterprise.vue"
export default component.exports